export default "__VITE_ASSET__454ff30a__"